<app-moniepoint-dialog [dialogType]="'error'">
	<div class="flex flex-col" [ngClass]="isMobile ? '' : 'px-[20px]'">
		<div class="font-bold text-[28px] text-center my-[8px]">
			All your accounts are closed
		</div>
		<div class="text-center mb-[40px]">
			To resume enjoying Moniepoint account benefits, please contact us
		</div>
		<div class="flex flex-col gap-[24px] rounded-[16px] py-[20px] px-[24px] bg-white border border-dashed border-[#CDDDFC]">
			<div class="flex gap-[24px]">
				<div class="flex-1 flex flex-col">
					<div class="flex-1 text-[12px] font-medium text-[#808080]">Phone Number</div>
					<div class="text-[12px] font-medium">+234 201 888 9990</div>
				</div>
				<a class="support-btn" href="tel:+2342018889990">
					<span nz-icon [nzType]="'phone'"></span>
					Call
				</a>
			</div>
			<div class="flex gap-[24px]">
				<div class="flex-1 flex flex-col">
					<div class="text-[12px] font-medium text-[#808080]">Email</div>
					<div class="text-[12px] font-medium">{{'support@moniepoint.com'}}</div>
				</div>
				<a class="support-btn" href="mailto:support@moniepoint.com">
					<span nz-icon [nzType]="'mail'"></span>
					Email
				</a>
			</div>
		</div>
		<div class="flex gap-4 mb-5 justify-end mt-[40px]">
			<app-kamona-custom-button (submitForm)="logout()" [isBlock]="true" [type]="'primary'"
				text="Logout"></app-kamona-custom-button>
		</div>
	</div>
</app-moniepoint-dialog>
